<template>
<div class="container">
<keep-alive>
<mt-loadmore :bottom-method="loadMore" bottomDropText="加载更多" :auto-fill="false" :bottom-all-loaded="!hadmore" ref="loadmore">
	<ul class="list">
		 <div class="row item" @click='linkto(v)' v-for="v in list" :key="v.id">
			<div class="col-3">
				<img :src="picurl+(v.pic?v.pic:default_img)" :alt="v.title" @error="err(v)">
			</div>
			<div class="col-7">
				<h4 class="item-header" v-html="v.title"></h4>
				<p class="item-footer">
				<span>阅读({{v.visit}})</span>
				<span>{{v.time}}</span>
				</p>
			</div>
		 </div>	
	</ul>

<div class="row center" style="padding:1rem;" v-show="list.length>0&&hadmore">
   <mt-button size="small" @click="loadMore">点击查看更多</mt-button>
</div>

<nomore v-show="!hadmore"></nomore>

</mt-loadmore>	
</keep-alive>
</div>

</div>	
</template>

<style scoped>
h4{font-weight: 500;font-family: "微软雅黑";}
.item{height:120px;  display: flex;align-items:center;}
.col-3 img{width:100%;max-height:100px;}	
.item-header{height:42px;line-height:21px;text-overflow: ellipsis;overflow: hidden;
	padding:0 .5rem;}
.msg{text-align: center;padding:1rem;font-size: 1rem;line-height:1.5rem;height:1.5rem;color:#ddd;}
</style>

<script>
import nomore from "../../lib/nomore.vue";

export default{
	data:function(){
		return{
         list:[],
         picurl:picurl,
         hadmore:true,
         mydata:mydata,
         ifrom:"",
         default_img:"default.jpg",
		};
	},
	components:{nomore},
	watch: {
      '$route': 'getlist'
    },
	created:function(){
        this.getlist();
        console.log(mydata.position);
        fun.toy(mydata.position);
	},
	methods:{
      getlist:function(len){
      	this.setfrom();
      	var data={
			'nid':this.$route.params.id,
			'len':len>0?len:0,
		}
		var _this=this;
		// if(data.len==0&&fun.cache(fun.url())){
		// 	this.list=fun.cache(fun.url());return;
		// }
      	fun.post(api+"getlist",data,function(d){
	    	 console.log(d);
	    	_this.$refs.loadmore.onBottomLoaded();
	    	if(d.status==1){
	    		if(data.len>0){
	    			_this.list=_this.list.concat(d.info);
	    		}else{
	    			_this.list=d.info;
	    			//_this.mydata.nav=d.info[0]['nav'];
	    		}
	    		fun.cache(fun.url(),_this.list);
	    	}else{
	    		_this.$toast(d.info);
	    		_this.hadmore=false;
	    	}
	    })
      },
     setfrom:function(){
      	if(this.$route.path.match(/hs/)){
			this.ifrom="/hs";
		}else{
			this.ifrom="/thm";
		}
	 },
     loadMore:function(){
      	this.loading=true;
      	var len=this.list.length;
      	if(len>0&&this.hadmore){
      		this.getlist(len);
      	}
      },
      err:function(v){
      	v.pic=this.default_img;
      },
      linkto:function(v){
      	var url=this.ifrom+'/acticle/nid/'+v.nid+'/b/'+v.aid;
        fun.saveposition();
      	fun.link(url);
      }
	}
}	
</script>


// WEBPACK FOOTER //
// src/components/thm/index.vue